// extracted by mini-css-extract-plugin
export default {"background__color":"app_background__color__VXoNw"};